export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/a70fe28c30edbe909cade8425716fdee.svg";